'use client'

import { useReportErrorOnce } from '@repo/analytics/sentry/react'
import { ErrorPage } from '@repo/features/error'
import { ComponentProps } from 'react'

export default function ProtectedError(props: ComponentProps<typeof ErrorPage>) {
  useReportErrorOnce(props.error)

  return <ErrorPage {...props} data-sentry-element="ErrorPage" data-sentry-component="ProtectedError" data-sentry-source-file="error.tsx" />
}
